import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IExpense } from '../expenses.interface';
import { ExpensesService } from '../expenses.service';
import * as _ from 'lodash';
import { ICategory } from '../../../categories-page/categories/categories.interface';
import { Unit } from '../../../../shared/constants/unit.constants';
import { CategoriesService } from '../../../categories-page/categories/categories.service';
import { AuthService } from '../../../../shared/services/auth.service';

let self: any;

@Component({
  selector: 'app-expenses-modal',
  templateUrl: './expenses-modal.component.html',
  styleUrls: ['./expenses-modal.component.css']
})
export class ExpensesModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  expense!: IExpense;
  form!: UntypedFormGroup;
  submitted = false;
  categories: ICategory[] = [];
  isDev!: boolean;
  curr!: string;
  unitList = Unit;
  unitListKeys = Object.keys(Unit);
  constructor(
    public _ExpensesService: ExpensesService,
    public _CategoriesService: CategoriesService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private _AuthService: AuthService
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.curr = this._AuthService.currency();
    this.isDev = this._AuthService.isRole('dev');
    if (this.expense._id) this.getExpense();
    else this.buildForm();
  }

  getExpense() {
    this.loading = true;
    this._ExpensesService.getExpense(this.expense._id || '').subscribe((expense) => {
      this.expense = expense;
      this.buildForm();
      this.loading = false;
    });
  }

  get f() { return this.form.controls; }
  buildForm() {
    this.form = this.fb.group({
      name: [this.expense.name, [Validators.required]],
      description: [this.expense.description],
      amount: [this.expense.amount, [Validators.compose([Validators.required, Validators.min(0)])]],
      isDeleted: [this.expense.isDeleted]
    });
  }

  setEditable(value: boolean = false) {
    this.readOnly = value;
  }

  onSubmit() {
    this.submitted = true;
    let data: IExpense = _.cloneDeep(this.form.value);
    if (this.form.invalid) return;
    this.saving = true;
    data.company = this._AuthService.companyId();
    if (this.expense._id) {
      data._id = this.expense._id;
      this._ExpensesService.updateExpense(data).subscribe((expense) => {
        this.dialog.close(expense);
      });
    } else {
      this._ExpensesService.createExpense(data).subscribe((expense) => {
        this.dialog.close(expense);
      });
    }
  }

  cancelSubmit() {
    if (!this.expense._id) return this.dialog.close();
    Object.keys(this.form.controls).forEach((key) => this.form.controls[key].setErrors(null));
    this.setEditable(true);
    this.getExpense();
  }
}